import React, { Component, useMemo } from "react";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import { Link, Route, useLocation } from "react-router-dom";
import Switch from "@mui/material/Switch";
import moment from "moment-jalaali";
function DataGrid({ data }) {
  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "name",
        Header: "نام",
        minWidth: 120,
      },

      {
        accessor: "nameEn",
        Header: "نام انگلیسی",
        minWidth: 120,
      },
      {
        accessor: "address",
        Header: "آدرس",
        minWidth: 100,
      },
      {
        accessor: "phoneNumber",
        Header: "تلفن",
        minWidth: 100,
      },
      {
        Header: "وضعیت",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Switch
              checked={row.original.status ? true : false}
              //checked={state.checkedA}
              value="row.original.active"
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
              // onChange={handleChange(row.original)}
            />
          </div>
        ),
      },
      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: 90,
        maxWidth: 90,
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* ویرایش */}

            <Link
              to={"/createOrEditPlace/" + `${row.original.id}`}
              className="btn btn-light-primary btn-sm mr-2 btn-icon"
            >
              <i className="far fa-edit text-small"></i>
            </Link>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
